'use client';
import useV2Position from '@/application/read/migrate/useV2Position';
import useV2Vaults from '@/application/read/migrate/useV2Vaults';
import useAddress from '@/application/read/web3/useAddress';
import useUnstakeLiquidity from '@/application/write/migrate/useUnstakeLiquidity';
import { useEffect, useState } from 'react';
import MigrateXSlp from './MigrateXSlp';
import useVault from '@/application/read/vaults/useVault';
import { useModalContext } from '@/presentation/context/modal';
import Icon, { Icons } from '../../elements/Icon';

export type Props = {
  v3VaultId: string;
  fullRange: boolean;
  positionId: string;
};

const MigrateXSlpContainer = ({ fullRange, positionId, v3VaultId }: Props) => {
  const { showMigrateModal, showMigrateSlpModal } = useModalContext();
  const userAddress = useAddress();
  const { data } = useV2Position({ positionId, userAddress });
  const [position, setPosition] = useState(data);
  const { data: v2Vaults } = useV2Vaults();
  const { data: v3Vault } = useVault({ vaultId: v3VaultId });

  useEffect(() => {
    if (data) {
      setPosition(data);
    }
  }, [data]);

  const v2Vault =
    v2Vaults &&
    position &&
    v2Vaults.find((vault) => vault.vaultId === position.vaultId);

  const [unstakeLiquidity, { status: unstakeStatus, error: unstakeError }] =
    useUnstakeLiquidity();

  const handleCancel = () => {
    showMigrateModal({ positionId });
  };
  const handleComplete = () => {
    const newId = `slp-${v2Vault?.vaultId}`;
    const migrateOption = position?.migrateOptions.find(
      (o) => o.vaultId === v3VaultId
    );
    const minVToken = migrateOption?.maxVToken || BigInt(0);

    showMigrateSlpModal({
      positionId: newId,
      v3VaultId,
      fullRange,
      showXSlpSteps: true,
      minVToken,
    });
  };

  if (!position || !v2Vault || !v3Vault) {
    return (
      <div className="p-6 flex items-center justify-center">
        <Icon name={Icons.SPINNER_GAP} className="animate-spin" size={24} />
      </div>
    );
  }

  return (
    <MigrateXSlp
      v3VaultId={v3VaultId}
      position={position}
      unstakeError={unstakeError}
      unstakeLiquidity={unstakeLiquidity}
      unstakeStatus={unstakeStatus}
      onComplete={handleComplete}
      onCancel={handleCancel}
    />
  );
};

export default MigrateXSlpContainer;
